
import state from './customersState.js'
import * as mutations from './customersMutations.js'
import * as actions from './customersActions.js'
import * as getters from './customersGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}